console.log("observer.js loaded");

document.addEventListener("DOMContentLoaded", function() {
  console.log("DOMContentLoaded fired");

  //--------------------------------------------------
  // 一、針對 .money 元素進行錯誤格式修正
  //--------------------------------------------------
  function checkAndFixMoney(el) {
    const originalText = el.textContent.trim();
    // 若發現 "TWD$" 或 "$NaN"，代表格式錯誤
    if (originalText.includes("TWD$") || originalText.includes("$NaN")) {
      console.log("偵測到錯誤金額格式 ->", originalText);
      let fixedAmount = originalText.replace(/\(\$NaN\)/g, "");
      fixedAmount = fixedAmount.replace(/TWD\$/g, "");
      fixedAmount = fixedAmount.trim();
      // 用正則擷取數字與可能的幣別
      const match = fixedAmount.match(/^[^\d]*([\d,]+(\.\d+)?)(?:\s+([A-Za-z]+))?$/);
      if (match) {
        const numericPart = match[1];
        const currency = match[3] || "";
        if (currency) {
          el.textContent = `$${numericPart} ${currency}`;
        } else {
          el.textContent = `$${numericPart}`;
        }
        console.log("已修正 ->", el.textContent);
      } else {
        console.log("未能找到數字部分，維持原狀 ->", originalText);
      }
    }
  }

  // 監控整個 document.body
  const moneyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches(".money")) {
              checkAndFixMoney(node);
            } else {
              node.querySelectorAll(".money").forEach(function(child) {
                checkAndFixMoney(child);
              });
            }
          }
        });
      } else if (mutation.type === "characterData") {
        const parent = mutation.target.parentElement;
        if (parent && parent.matches(".money")) {
          checkAndFixMoney(parent);
        }
      }
    });
  });
  moneyObserver.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  // 初次載入時掃描所有 .money
  document.querySelectorAll(".money").forEach(function(el) {
    checkAndFixMoney(el);
  });

  // 短期以 setInterval 繼續掃描錯誤格式
  const intervalId = setInterval(function() {
    const moneyEls = document.querySelectorAll(".money");
    let errorFound = false;
    moneyEls.forEach(function(el) {
      const text = el.textContent.trim();
      if (text.includes("TWD$") || text.includes("$NaN")) {
        errorFound = true;
        checkAndFixMoney(el);
      }
    });
    if (!errorFound) {
      clearInterval(intervalId);
      console.log(`所有金額格式已正確修正，停止 setInterval 監控，時間：${new Date().toLocaleString()}`);
    }
  }, 1000);

  //--------------------------------------------------
  // 二、初始化「單一商品」原始金額 dataset
  //--------------------------------------------------
  // BEST Currency Converter / Shopify 只會給出 "doubly-currency-xxx" 是「單件商品」的金額（最小單位）
  // 例：doubly-currency-twd="2500000" => 單件 25,000 TWD
  //     doubly-currency-usd="76181.18925000001" => 單件 761.8118925 USD
  //     doubly-currency-jpy="11567963.862415114" => 單件 115679.63862415114 JPY
  function initOriginalDataset(moneyEl) {
    // 可擴充更多幣別
    const currencyList = ["TWD", "USD", "JPY"];
    currencyList.forEach(function(cur) {
      const attrName = "doubly-currency-" + cur.toLowerCase();
      const valStr = moneyEl.getAttribute(attrName);
      if (valStr) {
        // 除以100
        const valNum = parseFloat(valStr) / 100;
        moneyEl.dataset["original" + cur] = valNum.toString();
      }
    });
  }

  //--------------------------------------------------
  // 三、以「購買件數 × 單一商品」金額為基礎的幣別轉換函式
  //--------------------------------------------------
  // convertMoney(moneyEl, newCurrency):
  //   1) 從文字解析「舊幣別」與「舊金額(整筆)」
  //   2) 透過 (舊金額 / 單件(舊幣別)) => 購買件數
  //   3) 購買件數 × 單件(新幣別) => 新整筆金額
  function convertMoney(moneyEl, newCurrency) {
    // 若尚未初始化，就從屬性讀取單一商品的 TWD/USD/JPY
    if (!moneyEl.dataset.originalTWD && !moneyEl.dataset.originalUSD && !moneyEl.dataset.originalJPY) {
      initOriginalDataset(moneyEl);
    }

    // 取得三種單一商品金額
    const origTwd = parseFloat(moneyEl.dataset.originalTWD || "0");
    const origUsd = parseFloat(moneyEl.dataset.originalUSD || "0");
    const origJpy = parseFloat(moneyEl.dataset.originalJPY || "0");

    // 取得新幣別「單一商品」金額
    const origNewVal = parseFloat(moneyEl.dataset["original" + newCurrency] || "0");
    if (origTwd <= 0 || origNewVal <= 0) {
      console.log("原始 TWD 或新幣別資料為 0，無法換算 => TWD:", origTwd, newCurrency, origNewVal);
      return;
    }

    // 從文字解析舊金額 & 舊幣別
    const rawText = moneyEl.textContent.trim(); // 例："¥462718.55 JPY"
    const oldValue = parseFloat(rawText.replace(/[^0-9.]/g, "")) || 0;
    if (oldValue <= 0) {
      console.log("無法解析舊金額 =>", rawText);
      return;
    }
    // 判斷舊幣別
    let oldCurrency = "TWD"; // fallback
    if (rawText.includes("USD")) oldCurrency = "USD";
    else if (rawText.includes("JPY")) oldCurrency = "JPY";
    else if (rawText.includes("TWD")) oldCurrency = "TWD";

    // 取得「單一商品(舊幣別)」金額
    const origOldVal = parseFloat(moneyEl.dataset["original" + oldCurrency] || "0");
    if (origOldVal <= 0) {
      console.log("舊幣別單一商品資料為 0 =>", oldCurrency);
      return;
    }

    // 步驟 1：推算購買件數 = (舊整筆金額 / 單件(舊幣別))
    // 例如 462718.55 JPY / 115679.63 = ~4 件
    const itemCount = oldValue / origOldVal;

    // 步驟 2：新整筆金額 = (購買件數) × (單一商品的新幣別金額)
    let converted = itemCount * origNewVal;
    converted = converted.toFixed(2);

    // 貨幣符號對照
    const currencySymbols = {
      TWD: "$ ",
      USD: "$",
      JPY: "¥"
    };
    const symbol = currencySymbols[newCurrency] || "";
    const formattedValue = `${symbol}${converted} ${newCurrency}`;

    moneyEl.textContent = formattedValue;
    console.log(`手動切換幣別: ${oldCurrency} => ${newCurrency}, ${rawText} => ${formattedValue}, (件數=${itemCount})`);
  }

  //--------------------------------------------------
  // 四、自動監控 subtotal：當小計文字改變時，用「購買件數 × 單件(目標幣別)」算總額
  //--------------------------------------------------
  // Shopify/BEST Currency Converter 若改變文字 => e.g. "$100,000.00"，實際 4 件 * 25,000
  let subtotalObserver = null;
  let subtotalExistenceObserver = null;
  let isUpdatingSubtotal = false;

  function checkAndConvertSubtotal() {
    if (isUpdatingSubtotal) return;
    const subtotalElement = document.querySelector(".productView-subtotal");
    if (!subtotalElement) return;
    const moneyEl = subtotalElement.querySelector(".money");
    if (!moneyEl) return;

    // 目標幣別
    const targetCurrency = (moneyEl.getAttribute("doubly-currency") || "TWD").toUpperCase();
    const rawText = moneyEl.textContent.trim();
    // 若文字已包含目標幣別 => 可能上次已轉過 => 避免遞迴
    if (rawText.includes(targetCurrency)) {
      console.log("文字已是 " + targetCurrency + "，跳過 ->", rawText);
      return;
    }

    // 先初始化單一商品
    if (!moneyEl.dataset.originalTWD && !moneyEl.dataset.originalUSD && !moneyEl.dataset.originalJPY) {
      initOriginalDataset(moneyEl);
    }

    // 從文字解析「整筆台幣」 => e.g. "$100,000.00" => 100000
    // 這是「台幣小計」，BEST Currency Converter 可能顯示數字但不帶 TWD
    const currentTwd = parseFloat(rawText.replace(/[^0-9.]/g, "")) || 0;
    if (currentTwd <= 0) {
      console.log("無法解析 TWD 小計 =>", rawText);
      return;
    }

    // 取得單一商品 TWD
    const singleTWD = parseFloat(moneyEl.dataset.originalTWD || "0");
    if (singleTWD <= 0) {
      console.log("單一商品 TWD 為 0 => 無法換算");
      return;
    }

    // 推算購買件數
    const itemCount = currentTwd / singleTWD;

    // 取得「單一商品(目標幣別)」 => e.g. dataset.originalUSD
    const singleTarget = parseFloat(moneyEl.dataset["original" + targetCurrency] || "0");
    if (singleTarget <= 0) {
      console.log("目標幣別單一商品為 0 =>", targetCurrency);
      return;
    }

    // 計算新整筆金額 => (購買件數) * (單一商品(目標幣別))
    let convertedAmount = itemCount * singleTarget;
    convertedAmount = convertedAmount.toFixed(2);

    const currencySymbols = {
      TWD: "$ ",
      USD: "$",
      JPY: "¥"
    };
    const symbol = currencySymbols[targetCurrency] || "";
    const formattedValue = symbol + convertedAmount + " " + targetCurrency;

    isUpdatingSubtotal = true;
    moneyEl.textContent = formattedValue;
    isUpdatingSubtotal = false;
    console.log(`Subtotal 匯率換算更新 => ${rawText} => ${formattedValue}, (件數=${itemCount})`);
  }

  function initSubtotalObserver() {
    const subtotalElement = document.querySelector(".productView-subtotal");
    if (!subtotalElement) return;
    subtotalObserver = new MutationObserver(function() {
      checkAndConvertSubtotal();
    });
    subtotalObserver.observe(subtotalElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: [
        "doubly-currency-twd",
        "doubly-currency-usd",
        "doubly-currency-jpy",
        "doubly-currency"
      ]
    });
    console.log("Subtotal observer 啟動");
    checkAndConvertSubtotal();
  }

  subtotalExistenceObserver = new MutationObserver(function() {
    const subtotalElement = document.querySelector(".productView-subtotal");
    if (subtotalElement) {
      if (!subtotalObserver) {
        initSubtotalObserver();
      }
    } else {
      if (subtotalObserver) {
        subtotalObserver.disconnect();
        subtotalObserver = null;
        console.log("Subtotal 區塊不存在，停止 subtotal observer");
      }
    }
  });
  subtotalExistenceObserver.observe(document.body, { childList: true, subtree: true });

  //--------------------------------------------------
  // 五、提供全域函式：手動切換幣別
  //--------------------------------------------------
  // 用法： switchCurrency("USD"); 或 switchCurrency("JPY");
  window.switchCurrency = function(newCurrency) {
    // 針對 .productView-subtotal 內的 .money 做切換
    const moneyEl = document.querySelector(".productView-subtotal .money");
    if (!moneyEl) {
      console.log("找不到 subtotal .money");
      return;
    }
    convertMoney(moneyEl, newCurrency.toUpperCase());
  };

  console.log("Script loaded!");
});